import React from 'react';
import styled from 'styled-components';

import { Estimations, EstimationsProps } from '../Estimations';
import VenueCard, { VenueCardProps } from '../VenueCard';

type BasketDiscountPreviewProps = EstimationsProps & Partial<VenueCardProps>;

const StyledRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const BannerContainer = styled.div`
  margin: 0 16px;
`;

const BasketDiscountPreview = ({ venueDetails, banner, ...estimationsProps }: BasketDiscountPreviewProps) => {
  return (
    <StyledRoot>
      {venueDetails ? (
        <VenueCard venueDetails={venueDetails} banner={banner} />
      ) : (
        !!banner && <BannerContainer>{banner}</BannerContainer>
      )}
      <Estimations {...estimationsProps} />
    </StyledRoot>
  );
};

export default BasketDiscountPreview;
